const password = {
    unsupported_encryption_method: 'Метод шифрования {{name}} не поддерживается.',
    pepper_not_found: 'Не найден пепер пароля. Пожалуйста, проверьте ваши основные envs.',
    rejected: 'Пароль отклонен. Пожалуйста, проверьте, соответствует ли ваш пароль требованиям.',
};
export default Object.freeze(password);
